import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { CRM_PERMISSION_CODES } from 'permissions/constants/crmPermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { CRM_PERMISSION_CODES };

const usePermissionsCrm = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.CRM),
      canAccessClients: hasPermission(CRM_PERMISSION_CODES.CLIENTS),
      canViewClientsSection: hasPermission(
        CRM_PERMISSION_CODES.CLIENTS_VIEW_SECTION
      ),
      canCreateClient: hasPermission(CRM_PERMISSION_CODES.CREATE_CLIENT),
      canDownloadExcel: hasPermission(CRM_PERMISSION_CODES.DOWNLOAD_EXCEL),
      canAccessClientDetail: hasPermission(CRM_PERMISSION_CODES.CLIENT_DETAIL),
      canViewClientDetailSection: hasPermission(
        CRM_PERMISSION_CODES.CLIENT_DETAIL_VIEW_SECTION
      ),
      canEditClient: hasPermission(CRM_PERMISSION_CODES.EDIT_CLIENT),
      canViewInactiveBlockedClient: hasPermission(
        CRM_PERMISSION_CODES.VIEW_INACTIVE_BLOCKED_CLIENT
      ),
      canToggleClientActive: hasPermission(
        CRM_PERMISSION_CODES.TOGGLE_CLIENT_ACTIVE
      ),
      canAccessRutMonitoring: hasPermission(
        CRM_PERMISSION_CODES.RUT_MONITORING
      ),
      canViewRutMonitoringSection: hasPermission(
        CRM_PERMISSION_CODES.RUT_MONITORING_VIEW_SECTION
      ),
      canAddClient: hasPermission(CRM_PERMISSION_CODES.ADD_CLIENT),
      canViewClientDetail: hasPermission(
        CRM_PERMISSION_CODES.VIEW_CLIENT_DETAIL
      ),
      canRemoveFromMonitoring: hasPermission(
        CRM_PERMISSION_CODES.REMOVE_FROM_MONITORING
      ),
      canAccessCollections: hasPermission(CRM_PERMISSION_CODES.COLLECTIONS),
      canAccessAgenda: hasPermission(CRM_PERMISSION_CODES.AGENDA),
      canManageAutomations: hasPermission(
        CRM_PERMISSION_CODES.MANAGE_AUTOMATIONS
      ),
      canAccessGeneralInformation: hasPermission(
        CRM_PERMISSION_CODES.GENERAL_INFORMATION
      ),
      canAccessClientCalls: hasPermission(CRM_PERMISSION_CODES.CLIENT_CALLS),
      canAccessClientEmails: hasPermission(CRM_PERMISSION_CODES.CLIENT_EMAILS),
      canAccessClientContracts: hasPermission(
        CRM_PERMISSION_CODES.CLIENT_CONTRACTS
      ),
      canAccessClientDocuments: hasPermission(
        CRM_PERMISSION_CODES.CLIENT_DOCUMENTS
      ),
      canAccessClientSacEeppTasks: hasPermission(
        CRM_PERMISSION_CODES.CLIENT_SAC_EEPP_TASKS
      ),
      canAccessClientSac: hasPermission(CRM_PERMISSION_CODES.CLIENT_SAC),
      canAccessClientSacLegacy: hasPermission(
        CRM_PERMISSION_CODES.CLIENT_SAC_LEGACY
      ),
      canAccessClientEepp: hasPermission(CRM_PERMISSION_CODES.CLIENT_EEPP),
      canAccessClientEeppLegacy: hasPermission(
        CRM_PERMISSION_CODES.CLIENT_EEPP_LEGACY
      ),
      canAccessClientAnalysis: hasPermission(
        CRM_PERMISSION_CODES.CLIENT_ANALYSIS
      ),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsCrm;
